var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.emailVerified
    ? _c(
        "b-tooltip",
        { attrs: { type: "is-warning", label: _vm.message, multilined: "" } },
        [
          _c("b-button", {
            attrs: {
              size: "is-medium",
              type: "is-warning",
              loading: _vm.loading,
              disabled: _vm.loading,
              "icon-left": "bell-ring"
            },
            on: { click: _vm.sendEmail }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }